import { Browser } from '@capacitor/browser';
import { isNativePlatform } from './capacitor';

export async function openExternalUrl(url: string): Promise<void> {
  if (!url) return;
  if (isNativePlatform()) {
    await Browser.open({ url, presentationStyle: 'popover' });
  } else {
    window.open(url, '_blank', 'noopener,noreferrer');
  }
}

export function openMailto(mailtoUrl: string): void {
  if (!mailtoUrl.startsWith('mailto:')) {
    return;
  }
  window.location.href = mailtoUrl;
}
